// http://www.quirksmode.org/js/cookies.html
let CookieUtil = function() {};

CookieUtil.prototype.segment = function(name, value) {
    return value ? '; ' + name + '=' + value : '';
};

CookieUtil.prototype.convertToExpiresStr = function(expires) {
    let expiresStr = '';

    switch (expires.constructor) {
        case Number:
            expiresStr =
                expires === Infinity
                    ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
                    : '; max-age=' + expires * 24 * 60 * 60;
            break;
        case String:
            expiresStr = '; expires=' + expires;
            break;
        case Date:
            expiresStr = '; expires=' + expires.toUTCString();
            break;
    }

    return expiresStr;
};

CookieUtil.prototype.createCookie = function(
    cookieKey,
    cookieValue,
    expires,
    path,
    domain,
    secure
) {
    let expiresStr = '';
    if (
        !cookieKey ||
        /^(?:expires|max\-age|path|domain|secure)$/i.test(cookieKey)
    ) {
        return false;
    }

    if (expires) {
        expiresStr = this.convertToExpiresStr(expires);
    }

    document.cookie =
        encodeURIComponent(cookieKey) +
        '=' +
        encodeURIComponent(cookieValue) +
        expiresStr +
        this.segment('domain', domain) +
        this.segment('path', path || '/') +
        this.segment('secure', secure);
    return true;
};

CookieUtil.prototype.readCookie = function(key) {
    return (
        decodeURIComponent(
            document.cookie.replace(
                new RegExp(
                    '(?:(?:^|.*;)\\s*' +
                        encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') +
                        '\\s*\\=\\s*([^;]*).*$)|^.*$'
                ),
                '$1'
            )
        ) || null
    );
};

CookieUtil.prototype.hasCookie = function(key) {
    return new RegExp(
        '(?:^|;\\s*)' +
            encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') +
            '\\s*\\='
    ).test(document.cookie);
};

CookieUtil.prototype.eraseCookie = function(key, path, domain) {
    if (!key || !this.readCookie(key)) {
        return false;
    }

    document.cookie =
        encodeURIComponent(key) +
        '=; expires=Thu, 01 Jan 1970 00:00:01 GMT' +
        this.segment('domain', domain) +
        this.segment('path', path || '/');

    return true;
};

export default new CookieUtil();



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/cookie.js